import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import { getGCSUrl } from '../../../../services/Common';
import './TakeNextMCQV2.css';
import { convertTime } from '../../../services/commonAPI';
import useFlagsFromBackend, { GB_FLAGS } from '../../../services/launchDarkly';
import { pushLog2DV2LogServer } from '../../../../services/logging';
import { getUserObject } from '../../../util/getUserFullName';

const TakeNextMCQV2 = React.memo(({ onSkipMCQ, nextMCQ, visible, totalStackTest, onNextClick, mcq_use_apiv1 }) => {
  const { $flagsReady, auto_redirect_to_test_page } = useFlagsFromBackend([GB_FLAGS.auto_redirect_to_test_page]);
  const [showModalForUser, setShowModalForUser] = useState(false);

  useEffect(() => {
    if ($flagsReady) {
      const user = getUserObject();
      setShowModalForUser(auto_redirect_to_test_page);
      pushLog2DV2LogServer.info('SHOW_NEXT_MCQ_MODAL', 'TEST_PAGE', {}, { user: user.id, show_next_test_modal: auto_redirect_to_test_page });
    }
  }, [$flagsReady]);

  const passStatus = localStorage.getItem('passStatus');
  const { challenge_name, icon, category, challenge_duration, proceed } = nextMCQ || { challenge_name: null, icon: null, category: null, challenge_duration: null, start: null };
   /**
   * Once `mcq_use_apiv1` is rolled out to 100% users, remove the check for mcq_use_apiv1 flag
   * and directly provide icon in the `<img src="" />` instead of GCSIcon
   */
   let GCSIcon = undefined;

   if (mcq_use_apiv1) {
     GCSIcon = icon;
   } else {
     GCSIcon = `${getGCSUrl()}/icon/${icon}`;
   }
  const defaultIcon = '/images/no-image.png';
  const category_name = (category || '').split(',')[0];

  let completed_challenge_name = null;
  let title = null;
  let description = null;
  if (passStatus && JSON.parse(passStatus)) {
    const passedData = JSON.parse(passStatus);
    completed_challenge_name = passedData.passed_challenge_name;
    const passed = passedData.passed;
    if (passed) {
      title = <span>You&apos;re on a roll...<br/>Take the next test now! 🚀</span>;
      description = <span>Congratulations on passing the {completed_challenge_name} test! Keep it going and take the <b>{challenge_name}</b> right away. The more tests you pass, the more likely you are to get a job.</span>;
    } else {
      title = <span>Chin up, you still got it... <br/>Take another test now! 🚀</span>;
      description = <span>Sorry you didn&apos;t pass the {completed_challenge_name} test! Don&apos;t worry, you can take this test in another 3 months. Try another test to strengthen your profile. The more tests you pass, the more likely you are to get a job.</span>;
    }
  }
  return (
    <Modal
      visible={visible && showModalForUser}
      footer={null}
      width="504px"
      className="turing-ui-v2-next_mcq_modal"
      bodyStyle={{ padding: 0, margin: 0 }}
      destroyOnClose
      centered
    >
      <div className='turing-ui-v2-next-mcq-modal-title'>{title}</div>
      <div className='turing-ui-v2-next-mcq-modal-description'>{description}</div>
      <Row type="flex">
        <Col span={12}>
          <div className='turing-ui-v2-next-mcq-card'>
            <Row type="flex" align="middle">
              <div className='turing-ui-v2-next-mcq-card-icon'>
                <img src={icon ? GCSIcon : defaultIcon} alt={challenge_name} />
              </div>
              <div>
                <div className='turing-ui-v2-next-mcq-card-category'>{category_name.toUpperCase()}</div>
                <div className='turing-ui-v2-next-mcq-card-challenge_name'>{challenge_name}</div>
                <div className='turing-ui-v2-next-mcq-duration'>{`${convertTime(challenge_duration)}`}</div>
              </div>
              <div className='turing-ui-v2-next-mcq-next-icon'>
                <Icon height="7.16" style={{ color: '#CCCCCC' }} fill="#CCCCCC" width="12.51" type="right" />
              </div>
            </Row>
          </div>
        </Col>
        {
          totalStackTest && totalStackTest > 1 ? (
            <Col className='turing-ui-v2-next-mcq-suggestion'>
              <span>I&apos;m not ready for this one,</span><br />
              <span onClick={onNextClick} className="turing-ui-v2-next-suggest">suggest a different test</span>
            </Col>
          ) : null
        }
      </Row>
      <Row type="flex">
        <Button onClick={proceed} type="primary">Take {challenge_name} test now</Button>
        <div className="skip-btn"><Button onClick={onSkipMCQ}>Skip for now</Button></div>
      </Row>
    </Modal>
  );
});

TakeNextMCQV2.propTypes = {
  onSkipMCQ: PropTypes.func,
  nextMCQ: PropTypes.object,
  visible: PropTypes.bool,
  totalStackTest: PropTypes.number,
  onNextClick: PropTypes.func,
  mcq_use_apiv1: PropTypes.bool
};
export default TakeNextMCQV2;
